import logo from '../assets/brand/logo.png';
import logoMark from '../assets/brand/logo-mark.png';
import { cn } from '../lib/cn';

interface LogoProps {
  /** `full` is mark plus wordmark; `mark` is the round icon only, e.g. for a collapsed sidebar */
  variant?: 'full' | 'mark';
  /** `light` is for dark backgrounds (the navy sidebar and brand panel): the mark with a white wordmark */
  tone?: 'dark' | 'light';
  className?: string;
}

/** Hemmafixa logo, the same files as the landing page (hemmafixa.se) */
export function Logo({ variant = 'full', tone = 'dark', className }: LogoProps) {
  if (variant === 'mark') {
    return <img src={logoMark} alt="Hemmafixa" width={40} height={40} className={cn('size-10', className)} />;
  }
  // The mark with the wordmark set in the brand font: crisp at any size, white on the navy brand panel
  return (
    <span className={cn('inline-flex h-10 items-center gap-2.5', className)}>
      <img src={logoMark} alt="" width={40} height={40} className="size-9" />
      <span
        className={cn(
          'text-xl font-semibold tracking-tight',
          tone === 'light' ? 'text-sidebar-foreground' : 'text-secondary',
        )}
      >
        Hemmafixa
      </span>
    </span>
  );
}

/** The landing page's full logo file, for places that need the exact artwork (emails, print) */
export const logoImage = logo;
